
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { type MaxLessonWatchCard } from '@xt/client/types/record-card'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class MaxLessonWatchCards extends Vue {
  @Prop() data: MaxLessonWatchCard
  @Prop({ default: true }) showRefreshBtn: boolean

  get watchHour() {
    return (this.data.numberData ? this.data.numberData / (60 * 60) : 0).toFixed(1)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
